import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]




export default /*@__PURE__*/_defineComponent({
  __name: 'DidIcon',
  props: {
  color: {
    type: String,
    default: '#C671C2'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M4.25508 11.5417L0.705078 7.84375L4.25508 4.17188L7.78008 7.84375L4.25508 11.5417ZM8.43008 21.9062V16.3676C7.36341 16.2753 6.30508 16.1554 5.25508 16.0078C4.20508 15.8602 3.15508 15.6562 2.10508 15.3958L2.48008 13.8333C3.90121 14.1806 5.32658 14.428 6.75618 14.5755C8.18578 14.7231 9.63653 14.7969 11.1084 14.7969C12.5803 14.7969 14.0311 14.7231 15.4607 14.5755C16.8903 14.428 18.3134 14.1806 19.7301 13.8333L20.1051 15.3958C19.0551 15.6562 18.0052 15.862 16.9555 16.0132C15.9058 16.1644 14.8473 16.2798 13.7801 16.3594V21.9062H8.43008ZM4.25508 9.38021L5.70508 7.84375L4.25508 6.33333L2.78008 7.84375L4.25508 9.38021ZM11.1021 5.76042C10.3374 5.76042 9.68841 5.48162 9.15508 4.92401C8.62175 4.36642 8.35508 3.68934 8.35508 2.89276C8.35508 2.0962 8.62273 1.42014 9.15803 0.864583C9.69331 0.309028 10.3433 0.03125 11.108 0.03125C11.8727 0.03125 12.5217 0.310052 13.0551 0.867656C13.5884 1.42524 13.8551 2.10233 13.8551 2.89891C13.8551 3.69547 13.5874 4.37153 13.0521 4.92708C12.5168 5.48264 11.8668 5.76042 11.1021 5.76042ZM11.1071 13.2083C10.6057 13.2083 10.1759 13.0224 9.81758 12.6505C9.45924 12.2786 9.28008 11.8316 9.28008 11.3094C9.28008 10.7872 9.45858 10.3394 9.81558 9.96615C10.1726 9.59288 10.6018 9.40625 11.1031 9.40625C11.6044 9.40625 12.0342 9.59219 12.3926 9.96406C12.7509 10.336 12.9301 10.783 12.9301 11.3052C12.9301 11.8274 12.7516 12.2752 12.3946 12.6484C12.0376 13.0217 11.6084 13.2083 11.1071 13.2083ZM11.1007 4.19792C11.4536 4.19792 11.7509 4.07357 11.9926 3.82487C12.2342 3.57619 12.3551 3.26803 12.3551 2.90039C12.3551 2.53277 12.2357 2.22309 11.997 1.97135C11.7582 1.71962 11.4624 1.59375 11.1095 1.59375C10.7565 1.59375 10.4592 1.7181 10.2176 1.9668C9.97591 2.21548 9.85508 2.52364 9.85508 2.89128C9.85508 3.2589 9.97445 3.56858 10.2132 3.82031C10.4519 4.07205 10.7478 4.19792 11.1007 4.19792ZM16.5551 11.2292L15.0051 8.36458L16.5634 5.5H19.6801L21.2301 8.36458L19.6718 11.2292H16.5551ZM17.4218 9.66667H18.8051L19.5051 8.36458L18.8134 7.0625H17.4301L16.7301 8.36458L17.4218 9.66667Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})